import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var Item = styled(Box).withConfig({
  componentId: "sc-9ueux3-0"
})([""]);
Item.displayName = "Group.Item";
var Group = styled(Box).withConfig({
  componentId: "sc-9ueux3-1"
})(["display:flex;flex-direction:", ";margin:0;> ", ":not(:last-child){margin-right:", ";margin-bottom:", ";margin-left:", ";margin-top:", ";}"], function (_ref) {
  var direction = _ref.direction;

  switch (direction) {
    case "vertical":
      return "column";

    case "horizontal-reverse":
      return "row-reverse";

    case "vertical-reverse":
      return "column-reverse";

    default:
      return "row";
  }
}, Item, function (_ref2) {
  var _ref2$gutter = _ref2.gutter,
      gutter = _ref2$gutter === void 0 ? "md" : _ref2$gutter,
      direction = _ref2.direction;
  return direction === "horizontal" && spacing(gutter);
}, function (_ref3) {
  var _ref3$gutter = _ref3.gutter,
      gutter = _ref3$gutter === void 0 ? "md" : _ref3$gutter,
      direction = _ref3.direction;
  return direction === "vertical" && spacing(gutter);
}, function (_ref4) {
  var _ref4$gutter = _ref4.gutter,
      gutter = _ref4$gutter === void 0 ? "md" : _ref4$gutter,
      direction = _ref4.direction;
  return direction === "horizontal-reverse" && spacing(gutter);
}, function (_ref5) {
  var _ref5$gutter = _ref5.gutter,
      gutter = _ref5$gutter === void 0 ? "md" : _ref5$gutter,
      direction = _ref5.direction;
  return direction === "vertical-reverse" && spacing(gutter);
});
var Styled = {
  Item: Item,
  Group: Group
};
export { Styled };